/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ActiveAlertResponse
 */
export interface ActiveAlertResponse {
    /**
     * 
     * @type {string}
     * @memberof ActiveAlertResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveAlertResponse
     */
    ruleId?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveAlertResponse
     */
    machineId?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveAlertResponse
     */
    machinePartId?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveAlertResponse
     */
    severity?: ActiveAlertResponseSeverityEnum;
    /**
     * 
     * @type {string}
     * @memberof ActiveAlertResponse
     */
    message?: string;
    /**
     * 
     * @type {Date}
     * @memberof ActiveAlertResponse
     */
    triggeredAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ActiveAlertResponse
     */
    acknowledgedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ActiveAlertResponse
     */
    resolvedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof ActiveAlertResponse
     */
    recommendedAction?: string;
}


/**
 * @export
 */
export const ActiveAlertResponseSeverityEnum = {
    Info: 'INFO',
    Warning: 'WARNING',
    Critical: 'CRITICAL'
} as const;
export type ActiveAlertResponseSeverityEnum = typeof ActiveAlertResponseSeverityEnum[keyof typeof ActiveAlertResponseSeverityEnum];


/**
 * Check if a given object implements the ActiveAlertResponse interface.
 */
export function instanceOfActiveAlertResponse(value: object): value is ActiveAlertResponse {
    return true;
}

export function ActiveAlertResponseFromJSON(json: any): ActiveAlertResponse {
    return ActiveAlertResponseFromJSONTyped(json, false);
}

export function ActiveAlertResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActiveAlertResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'ruleId': json['ruleId'] == null ? undefined : json['ruleId'],
        'machineId': json['machineId'] == null ? undefined : json['machineId'],
        'machinePartId': json['machinePartId'] == null ? undefined : json['machinePartId'],
        'severity': json['severity'] == null ? undefined : json['severity'],
        'message': json['message'] == null ? undefined : json['message'],
        'triggeredAt': json['triggeredAt'] == null ? undefined : (new Date(json['triggeredAt'])),
        'acknowledgedAt': json['acknowledgedAt'] == null ? undefined : (new Date(json['acknowledgedAt'])),
        'resolvedAt': json['resolvedAt'] == null ? undefined : (new Date(json['resolvedAt'])),
        'recommendedAction': json['recommendedAction'] == null ? undefined : json['recommendedAction'],
    };
}

export function ActiveAlertResponseToJSON(value?: ActiveAlertResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'ruleId': value['ruleId'],
        'machineId': value['machineId'],
        'machinePartId': value['machinePartId'],
        'severity': value['severity'],
        'message': value['message'],
        'triggeredAt': value['triggeredAt'] == null ? undefined : ((value['triggeredAt']).toISOString()),
        'acknowledgedAt': value['acknowledgedAt'] == null ? undefined : ((value['acknowledgedAt']).toISOString()),
        'resolvedAt': value['resolvedAt'] == null ? undefined : ((value['resolvedAt']).toISOString()),
        'recommendedAction': value['recommendedAction'],
    };
}

